import PagedElements from "./pagedelements";
import AccountingGetSaleListViewModel from "../view/accountinggetsalelistviewmodel";

export default class PagedAccountingGetSales extends PagedElements<AccountingGetSaleListViewModel> {
    constructor(init?: Partial<PagedAccountingGetSales>) { super(init); }
}